import { info } from "@refinitiv-ui/elements/notification";

export default {
  enableSearch(){
    this.$refs.search.disabled = false;
  },
  resetSelectedValues(){
    let toggle = document.getElementById("changes-toggle")
    toggle.checked = true
    this.$refs.search.value = "";
    this.$refs.criteria.value = "";
    this.$refs.markets.values = [];
    this.$refs.search.disabled = true;
    this.resetPayload();
  },
  
  toBeImplement () {
    info('This feature has not been implemented.')
  },

  onChangesToggle() {
    let toggle = document.getElementById("changes-toggle")
    let dataToggle = document.getElementById("change-data-toggle")
    if(toggle.checked){
      dataToggle.disabled = false
    }else{
      dataToggle.disabled = true
    }
  },

  showWhatsNew() {
    this.$refs.whatsNewsOverlay.opened = true;
  },

  hideWhatsNew() {
    this.$refs.whatsNewsOverlay.opened = false;
  }
}